"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var change_1 = require("../change");

function onCut(editorState, event) {
  event.preventDefault();
  document.execCommand('copy');
  return change_1.removeRange(editorState, editorState.start, editorState.end);
}

exports.default = onCut;